import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../config/axios';
import logo from '../../assets/images/logo.png';
import ModalSelecionarUnidade from './modals/ModalSelecionarUnidade';
import '../../assets/styles/login.css';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModalUnidade, setShowModalUnidade] = useState(false);
  const [tempUser, setTempUser] = useState(null);
  const [tempToken, setTempToken] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    const cleanEmail = email.trim();
    const cleanSenha = senha.trim();

    if (!cleanEmail || !cleanSenha) {
      setErrorMessage('Por favor, preencha todos os campos.');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post('/login', {
        email: cleanEmail,
        password: cleanSenha
      });

      if (response.data) {
        const user = response.data.user;
        const token = response.data.token;
        const hasUnidadesVinculadas = user?.unidadesVinculadas && Array.isArray(user.unidadesVinculadas);

        if (hasUnidadesVinculadas && user.unidadesVinculadas.length > 1) {
          setTempUser(user);
          setTempToken(token);
          setShowModalUnidade(true);
        } else {
          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem('token', token);

          onLogin();
          navigate('/dashboard');
        }
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 401) {
          setErrorMessage('Email ou senha incorretos. Por favor, tente novamente.');
        } else {
          setErrorMessage('Erro ao fazer login. Por favor, tente novamente.');
        }
      } else if (err.request) {
        setErrorMessage('Erro ao conectar com o servidor. Por favor, tente novamente mais tarde.');
      } else {
        setErrorMessage('Erro ao processar a requisição. Por favor, tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleUnidadeSelecionada = () => {
    onLogin();
    setShowModalUnidade(false);
    navigate('/dashboard');
  };

  return (
    <div className="login-container">
      <div className="left-side">
        <div className="login-box">
          <img src={logo} alt="Logo do Cliente" className="client-logo-sm" />
          <h3 className="login-title">Bem-vindo</h3>
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="off"
                className="form-control"
                placeholder="Digite seu email"
              />
            </div>

            <div className="mb-4">
              <label className="form-label">Senha</label>
              <input
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                disabled={loading}
                autoComplete="off"
                className={`form-control ${errorMessage ? 'input-error' : ''}`}
                placeholder="Digite sua senha"
              />
            </div>

            <button type="submit" className="btn btn-custom-primary full-width" disabled={loading}>
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
      </div>
      <div className="right-side">
        <img src={logo} alt="Logo do Cliente" className="client-logo" />
      </div>

      <ModalSelecionarUnidade
        show={showModalUnidade}
        onSelectUnidade={handleUnidadeSelecionada}
        user={tempUser}
        tempToken={tempToken}
      />
    </div>
  );
}

export default Login;
